import {createSlice} from '@reduxjs/toolkit'
import {API_URL} from '../../Constants'
import { fetchDeconnexion } from '../connexion/connexionSlice'
import axios from 'axios'

export const initialState = {
  loading: false,
  hasErrors: false,
  rapports: [],
  cumul: false,
}

const rapportsSlice = createSlice({
  name: 'rapports',
  initialState,
  reducers: {
    getRapports: (state) => {
      state.loading = true
    },
    getRapportsSuccess: (state, {payload}) => {
      state.rapports = payload
      state.loading = false
      state.hasErrors = false
    },
    getRapportsFailure: (state) => {
      state.loading = false
      state.hasErrors = true
    },
    setRapportCumul: (state) => {
      state.cumul = true
    },
    unsetRapportCumul: (state) => {
      state.cumul = false
    }
  },
})

export const {getRapports, getRapportsSuccess, getRapportsFailure, setRapportCumul, unsetRapportCumul} = rapportsSlice.actions

export const rapportsSelector = (state) => state.rapports

export default rapportsSlice.reducer

export function fetchRapports() {
  return async (dispatch, getState) => {
    
    dispatch(getRapports())

    const cumul = getState().rapports.cumul;  

    try {

      const config = { 
        headers: {'Content-Type' : 'application/json'},
        withCredentials: true
      }

      if (cumul == false) {

        const response = await axios.get(API_URL+'/web/rapport', config)
        const data = await response.data
        dispatch(getRapportsSuccess(data))

      } else {

        const response = await axios.get(API_URL+'/web/rapport/cumul', config)
        const data = await response.data
        dispatch(getRapportsSuccess(data))

      }

  
    } catch (error) {

      if(error['response'] !== undefined) {
        if(error.response.status == 401) {
          dispatch(fetchDeconnexion())
        }
      }

      dispatch(getRapportsFailure())

    }

  }
}